var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"museum_addressMap"},[_c('div',[_c('div',{staticClass:"museum_addressMap_header"},[_c('img',{attrs:{"src":"static/images/cp_backbtn.svg","alt":"博物馆详情页面回退按钮"},on:{"click":function($event){return _vm.goRouter('back')}}})])]),_vm._v(" "),_c('div',{attrs:{"id":"allmap"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58ffc8b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/addressMap.vue
// module id = null
// module chunks = 